import React, { useEffect, useState } from "react";
import { useLocation } from "@reach/router";
import "../components/font-awsome";
import { graphql } from "gatsby";
import Layout from "~/components/layout";
import BannerComponent from "../components/banner";
import SubBannerComponent from "../components/subBanner";
import AdvertisingComponent from "../components/advertising";
import DownloadComponent from "../components/download";
import GameDemoComponent from "../components/gameDemo";
import { API_URL, GAME_LIST } from "gatsby-env-variables";
import * as Scroll from "react-scroll";
import Fade from 'react-reveal/Fade';
import SEO from "../components/seo";

let Element = Scroll.Element;
const scroller = Scroll.scroller;

const IndexPage = ({ data }) => {
  const [dataApi, setDataApi] = useState([]);
  const [listCate, setListCate] = useState([]);
  const [renderData, setRenderData] = useState([]);
  const [lazyData, setLazyData] = useState([]);
  const [currentType, setCurrentType] = useState("all");
  const [perPage] = useState(12);
  const [skip, setSkip] = useState(0);
  const bgname = "background_live22";
  const pageName = "live22";
  const bannerList = data.datoCmsLive22.banner;
  const subBannerList = data.datoCmsLive22.subbanner;
  const promoteList = {
    promote: data.datoCmsLive22.promote,
    image: data.datoCmsLive22.promoteImage,
  }
  const downloadList = {
    downloadContent: data.datoCmsLive22.downloadContent,
    downloadHeader: data.datoCmsLive22.downloadHeader,
    playStoreQr: data.datoCmsLive22.playStoreQr.url,
    appStoreQr: data.datoCmsLive22.appStoreQr.url,
    playStoreBanner: data.datoCmsLive22.playStoreBanner.url,
    appStoreBanner: data.datoCmsLive22.appStoreBanner.url,
  }
  // const common = data.common.edges[0].node.frontmatter;
  const { hash } = useLocation();

  useEffect(() => {
    fetch(`${API_URL}${GAME_LIST}`, {
      method: "POST",
    })
      .then((response) => response.json())
      .then((resultData) => {
        const res = resultData.data["live22Lists"].map((item) => ({
          gameId: item.gameId,
          provider: item.provider,
          image: item.image,
          name: item.name,
          type: item.type,
        }));
        const start = skip * perPage;
        const end = skip * perPage + perPage;
        setDataApi(res);
        setRenderData(res);
        setLazyData(res.slice(start, end));
      });
  }, []);

  useEffect(() => {
    const type = dataApi.map((item) => item.type);
    const mapCate = type
      .filter((v, i) => type.indexOf(v) === i)
      .map((item) => ({
        text: item,
        icon: item,
        type: item,
      }));
    setListCate([
      {
        text: "All Games",
        icon: "allgames",
        type: "all",
      },
      ...mapCate,
    ]);
  }, [dataApi]);

  useEffect(() => {
    const start = skip * perPage;
    const end = skip * perPage + perPage;
    const newLazyData = !skip
      ? [...renderData.slice(start, end)]
      : [...lazyData, ...renderData.slice(start, end)];
    setLazyData(newLazyData);
  }, [skip, renderData]);

  useEffect(() => {
    filterCate();
  }, [currentType]);

  const load = () => {
    setSkip(skip + 1);
  };

  const filterCate = () => {
    setSkip(0);
    const newRenderData = dataApi.filter((item) => {
      if (currentType === "all") return item;
      else return item.type === currentType.toUpperCase();
    });
    setRenderData(newRenderData);
  };

  useEffect(() => {
    if (hash === "#download") return onClickMenu();
  }, [hash]);

  const onClickMenu = (idx, element, offset = 0) => {
    scroller.scrollTo("DownloadComponent", {
      offset,
      duration: 10,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };
  return (
    <Layout
      pageName={pageName}>
      <SEO lang="th" />
      <div>
        <Fade bottom>
          <BannerComponent bannerList={bannerList} pageName={pageName} />
        </Fade>
        <Fade bottom>
          <SubBannerComponent subBannerList={subBannerList} pageName={pageName} />
        </Fade>
        <Fade bottom>
          <AdvertisingComponent
            promoteList={promoteList}
            pageName={pageName}
          />
        </Fade>
        <Fade bottom>
          <Element name="DownloadComponent">
            <DownloadComponent download={downloadList} pageName={pageName} />
          </Element>
        </Fade>
        <Fade bottom>
          <GameDemoComponent
            location={pageName}
            load={load}
            lazyData={lazyData}
            skip={skip}
            perPage={perPage}
            renderData={renderData}
            listCate={listCate}
            setCurrentType={setCurrentType}
          />
        </Fade>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query IndexPageTemplate {
    datoCmsLive22 {
      banner {
        url(imgixParams: {auto: "format", q: 90})
      }
      subbanner {
        url(imgixParams: {auto: "format", q: 90})
      }
      promoteImage {
        url(imgixParams: {auto: "format", q: 90})
      }
      promote {
        promoteHeader
        promoteContent
      }
      downloadContent
      downloadHeader
      playStoreQr {
        url(imgixParams: {auto: "format", q: 90})
      }
      playStoreBanner {
        url(imgixParams: {auto: "format", q: 90})
      }
      appStoreBanner {
        url(imgixParams: {auto: "format", q: 90})
      }
      appStoreQr {
        url(imgixParams: {auto: "format", q: 90})
      }
    }
  }
`;

export default IndexPage;
